import getClassName from "../../utilities/getClassName";

const Main = (props) => {
    return (
        <main id="main-content" tabIndex={-1} className={getClassName(["main", props.className].filter(Boolean))}>
            {props.children}
        </main>
    );
};

export default Main;
